// extracted by mini-css-extract-plugin
export default {"price":"q8-z","onSale":"r8-z","msrpLabelPrice":"s8-z","msrpLabel":"t8-z","originalPrice":"u8-z","percentOff":"v8-z"};